export class RequestPaymentOption {
    ID?: number;
    RequestID?: number;
    PaymentOptionID: number;
}

export default RequestPaymentOption;